exports.meterToFeet = (meters) => {
    return (meters * 1000) / (25.4 * 12);
};

exports.feetToMeter = (feet) => {
    return (feet * 25.4 * 12) / 1000;
};

exports.normalizeCameDir = (value, target, eye) => {
    const x = target[0] - eye[0];
    const y = target[1] - eye[1];
    const z = target[2] - eye[2];
    return value / Math.sqrt(x * x + y * y + z * z);
};

exports.degrees_to_radians = (degrees) => {
    // Store the value of pi.
    var pi = Math.PI;
    // Multiply degrees by pi divided by 180 to convert to radians.
    return (degrees) * (pi / 180);
};

exports.calcXYByAngleToNorth = (x, y, angle) => {
    const X = x * Math.cos(angle) - y * Math.sin(angle);
    const Y = x * Math.sin(angle) + y * Math.cos(angle);

    return { X, Y };
};
